<template>
  <div class="fourth__head__child">
    <div class="lesson__name" @click.stop="toggleTooltip">
      {{ lesson.name }}
    </div>

    <div v-if="showTooltip" class="custom-tooltip">
      {{ lesson.name }}
    </div>

    <div class="d-flex flex-column fourth__head noBorderLeft">
      <div class="d-flex fourth__body">
        <span v-for="(item, index) in lesson.grade" :key="`grade-${index}`" class="fourth__item grade">
          {{ item }}
        </span>
      </div>
    </div>

    <div class="total__body" v-if="showExamColumns">
      <div class="d-flex year__grade text-center">
        <span>{{ lesson.yearGrade }}</span>
      </div>
      <div class="d-flex year__grade text-center">
        <span>{{ lesson.exam }}</span>
      </div>
      <div class="d-flex exam__grade noBorderLeft text-center">
        <span>{{ lesson.final }}</span>
      </div>
    </div>

    <div v-else>
      <div class="d-flex year__grade__small text-center">
        <span>{{ lesson.yearGrade }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

defineProps({
  lesson: {
    type: Object,
    required: true
  },
  showExamColumns: {
    type: Boolean,
    default: false
  }
});

const showTooltip = ref(false);

function hideTooltip() {
  showTooltip.value = false;
}

function toggleTooltip() {
  if (showTooltip.value) {
    hideTooltip();
    return;
  }
  window.dispatchEvent(new Event('close-all-tooltips'));
  showTooltip.value = true;
}

onMounted(() => {
  document.addEventListener('click', hideTooltip);
  window.addEventListener('close-all-tooltips', hideTooltip);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', hideTooltip);
  window.removeEventListener('close-all-tooltips', hideTooltip);
});
</script>

<style scoped lang="scss">
.fourth__head__child {
  position: relative;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px dashed #bdbdbd;
  font-family: Roboto, sans-serif;
  min-height: 40px;

  @media screen and (min-width: 768px) {
    font-size: 20px;
    min-height: 54px;
  }
}

.lesson__name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 35%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.custom-tooltip {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 6px;
  z-index: 1000;
  background: #000;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  max-width: 260px;
  word-break: break-word;
}

.total__body {
  width: 40%;
  display: flex;
}

.fourth__head {
  border-left: 1px dashed #bdbdbd;
  border-right: 1px dashed #bdbdbd;
  width: 44%;
}

.fourth__body {
  display: flex;
  justify-content: space-between;
}

.fourth__item {
  height: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.year__grade__small {
  padding: 5px;
  align-items: center;
  justify-content: center;
}

.year__grade {
  align-items: center;
  justify-content: center;
  border-right: 1px dashed #bdbdbd;
  width: 100% !important;
  text-align: center;
}

.exam__grade {
  align-items: center;
  justify-content: center;
  width: 100% !important;
}

.grade {
  border-right: 1px dashed #bdbdbd;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;

  @media screen and (min-width: 768px) {
    min-height: 54px;
  }
}

.noBorderLeft {
  border-right: none !important;
}

@media screen and (max-width: 768px) {
  .lesson__name {
    width: 33%;
    min-width: 0;
    font-size: 14px;
  }

  .fourth__head {
    width: 34%;
    min-width: 0;
  }

  .total__body {
    width: 33%;
    min-width: 0;
  }

  .grade,
  .year__grade,
  .exam__grade,
  .year__grade__small {
    flex: 1 1 0;
    min-width: 0;
    font-size: 14px;
  }
}
</style>
